import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './assets/sass/style.scss'
import router from './router'
import store from './store'
import 'vue-select/dist/vue-select.css';
import VueGtag from "vue-gtag";
import * as Sentry from "@sentry/vue";
import { browserTracingIntegration, replayIntegration } from "@sentry/vue";
import { Capacitor } from '@capacitor/core'
import axios from 'axios'
import { initCapacitor } from '@/capacitor'
import { pushNotificationHandler } from '@/mobile/plugins/pushNotification'
import { setupAxiosInterceptor } from '@/services/axiosInterceptor'
const app = createApp(App);

// Initialize Sentry with error handling
Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  release: process.env.VUE_APP_VERSION,
  environment: process.env.NODE_ENV,
  integrations: [
    browserTracingIntegration({
      tracingOrigins: [
        "localhost", 
        /^\//, 
        /^https:\/\/.*\.mymembership\.id/,
        /^https:\/\/.*\.omnihotelier\.net/,
      ],
    }),
    replayIntegration({
      sessionSampleRate: 0.1,
      errorSampleRate: 1.0,
    }),
  ],
  tracesSampleRate: parseFloat(process.env.VUE_APP_TRACE_SAMPLE_RATE) || 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    return event;
  },
});

// Set global axios timeout
axios.defaults.timeout = 15000

//untuk handle request 401 (masih rnd)
setupAxiosInterceptor()

// Init network store SEBELUM mount — listener aktif sebelum route pertama resolve.
store.dispatch('network/init')

app.use(store).use(router).use(VueGtag, {
    config: {
        appName: 'Membership',
        pageTrackerScreenviewEnabled: true,
        id: process.env.VUE_APP_GA_MEASUREMENT_ID,
    }
}, router).mount('#app')

// Restore extranet tenant selection from localStorage
store.dispatch('extranet/restoreTenantSelection')

// Initialize Capacitor & push notifications on native platforms
if (Capacitor.isNativePlatform()) {
  const platform = Capacitor.getPlatform();
  document.documentElement.classList.add(`platform-${platform}`, 'is-native');
  document.body.classList.add(`platform-${platform}`, 'is-native');
  initCapacitor();
  pushNotificationHandler.initialize().catch(error => {
    console.error('Failed to initialize push notifications:', error)
    // Don't block app startup on push notification initialization failure
  })
} else {
  document.documentElement.classList.add('platform-web');
  document.body.classList.add('platform-web');
}

